
<template>
	<span>
		<span
			v-if="tooltip && rubric"
			class="empty-badge wide-badge badge px-1"
			v-tippy="{
				theme: 'popover',
				html: `#s-${mutScore.score_id}`,
				placement: tooltipPlacement,
				popperOptions: { preventOverflow: { enabled: false } }
			}"
		>
			<span
				v-if="mutScore.trait_scores.length && mutScore.trait_scores.length <= maxTraits"
				v-for="ts in mutScore.trait_scores"
				:key="ts.trait_id"
				class="badge"
				:class="{ disagreed: ts.disagreed, adjacent: ts.adjacent, 'text-extra-muted': ts.condition == '?' }"
			>
				{{ ts.score >= 0 ? ts.score : ts.condition }}
			</span>
			<span
				v-if="mutScore.trait_scores.length && mutScore.trait_scores.length > maxTraits"
				class="wide-badge px-2"
			>
				<span class="badge mr-1">
					<i class="fas fa-sliders-h faw mr-1"></i>{{ mutScore.trait_scores.length }}</span
				>
			</span>
			<div class="d-none p-0" :id="`s-${mutScore.score_id}`">
				<Score :score="score" :compareScore="compareScore" :rubric="rubric" :type="type" hideTime></Score>
			</div>
		</span>
		<span v-if="!(tooltip && rubric)" class="empty-badge wide-badge badge px-1">
			<span
				v-if="mutScore.trait_scores.length && mutScore.trait_scores.length <= maxTraits"
				v-for="ts in mutScore.trait_scores"
				:key="ts.trait_id"
				class="badge"
			>
				<span :class="{ disagreed: ts.disagreed, nonadj: ts.nonadj, adjacent: ts.adjacent }">{{
					ts.score
				}}</span>
			</span>
			<span
				v-if="mutScore.trait_scores.length && mutScore.trait_scores.length > maxTraits"
				class="wide-badge px-2"
			>
				<span class="badge mr-1">
					<i class="fas fa-sliders-h faw mr-1"></i>{{ mutScore.trait_scores.length }}</span
				>
			</span>
		</span>
	</span>
</template>

<script>
import Utils from "@/services/Utils";
import Score from "@/components/Score";
import moment from "moment";

export default {
	name: "InlineScore",
	props: {
		score: {
			default: null
		},
		compareScore: {
			default: null
		},
		tooltip: {
			type: Boolean,
			default: false
		},
		rubric: {
			default: null
		},
		type: {
			type: Number,
			default: null
		},
		tooltipPlacement: {
			type: String,
			default: "right-start"
		},
		maxTraits: {
			type: Number,
			default: 5
		}
	},
	components: { Score },
	data() {
		return {
			mutScore: null
		};
	},
	created() {
		this.loadData();
	},
	watch: {
		score() {
			this.loadData();
		},
		compareScore() {
			this.checkAgreement(this.mutScore, this.compareScore);
		}
	},
	methods: {
		loadData() {
			this.mutScore = _.cloneDeep(this.score);
			if (!this.mutScore.score_id) {
				this.mutScore.score_id = this.mutScore.id;
			}
			if (this.compareScore) {
				this.checkAgreement(this.mutScore, this.compareScore);
			}
		},

		checkAgreement(score, actual) {
			_.each(score.trait_scores, ts => {
				ts.disagreed = false;
				ts.nonadj = false;
				ts.adjacent = false;
				let comp = _.find(actual.trait_scores, {
					trait_id: ts.trait_id
				});
				if (comp && ts.score != comp.score) {
					ts.disagreed = true;
					if (Math.abs(comp.score - ts.score) > 1) {
						ts.nonadj = true;
					}
					if (Math.abs(comp.score - ts.score) == 1) {
						ts.adjacent = true;
					}
				}
			});
		}
	}
};
</script>

<style scoped>
.badge {
	width: 1.25rem;
	height: 1.5rem;
	line-height: 1.4rem;
	padding: 0 0;
	position: relative;
	color: rgba(70, 90, 110, 1);
}
.wide-badge {
	font-size: 1rem;
	width: initial !important;
}
.empty-badge {
	box-shadow: inset 0px 0px 0px 1.2px rgba(0, 0, 0, 0.2);
	background-color: white;
}
.disagreed::before {
	content: "";
	position: absolute;
	top: 0px;
	bottom: 2px;
	left: 0px;
	right: 0px;
	background-color: rgba(255, 0, 0, 0.2);
	border-radius: 0.4rem;
}
.disagreed.nonadj::before {
	border-bottom: 3px solid rgba(255, 0, 0, 0.5);
	border-top: 3px solid rgba(255, 0, 0, 0.5);
}
.adjacent {
}
.adjacent::before {
	background-color: rgba(253, 168, 41, 0.25);
}
</style>



// WEBPACK FOOTER //
// src/components/InlineScore.vue